// extracted by mini-css-extract-plugin
export default {"bottomBar":"BottomBar_bottomBar__rgtbL","icon":"BottomBar_icon__XJp3Z","container":"BottomBar_container__Owlbi","section":"BottomBar_section__flR33"};